export { default } from '../de/Privacy';



// WEBPACK FOOTER //
// ./src/components/async/dePrivacy.js